<template>
  <!-- `display: contents` (mesmo recurso que o .obj-text já usa): o wrapper
       existe só porque Vue 2 exige raiz única, e some do layout pra o botão
       participar direto do flex da linha. -->
  <div class="lesson-rating">
    <!-- App: botão + sheet. As 5 estrelas inline dão alvos de ~20px colados um
         no outro — no toque erra a nota, e o clique já grava sem chance de
         corrigir. Na web o hover funciona e o mouse acerta, então segue inline. -->
    <template v-if="$isApp">
      <info-action-button
        :label="btnLabel"
        :icon="value ? 'fa-star' : 'fa-star-o'"
        icon-set="fa"
        :color="value ? $theme.primaryColor : null"
        :border-color="value ? $theme.primaryColor : null"
        :title="btnTitle"
        @click="sheetVisible = true"
      />
      <rating-sheet
        :visible="sheetVisible"
        :initial-value="value"
        @select="onSelect"
        @cancel="sheetVisible = false"
      />
    </template>

    <div v-else class="content-rating">
      <div class="rating-love">
        <i
          v-for="i in 5"
          :key="i"
          :class="starClass(i)"
          @mouseover="hover = i"
          @mouseleave="hover = null"
          @click="submit(i)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import InfoActionButton from '@/components/InfoActionButton';
import RatingSheet from '@/components/RatingSheet';

// Avaliação da aula, nas duas apresentações. Quem usa não precisa saber qual
// delas está no ar — só monta o componente onde a nota deve aparecer.
//
// A nota vive num slot ÚNICO do store (`learningObject.ratings`), não por aula:
// quem troca de aula depende do `getRatings` ser redisparado. Por isso o
// componente não tenta cachear nada — lê sempre o store.
export default {
  name: 'LessonRating',
  components: { InfoActionButton, RatingSheet },
  props: {
    learningObject: { type: Object, required: true }
  },
  data () {
    return {
      sheetVisible: false,
      hover: null
    };
  },
  computed: {
    ...mapState({ ratings: (state) => state.learningObject.ratings }),
    value () {
      return (this.ratings && this.ratings.value) || 0;
    },
    btnLabel () {
      return this.value ? `Avaliado (${this.value})` : 'Avaliar';
    },
    btnTitle () {
      return this.value
        ? `Sua nota: ${this.value} de 5 — toque para alterar`
        : 'Avaliar este conteúdo';
    }
  },
  methods: {
    starClass (i) {
      const reference = this.hover || this.value;
      return i <= reference ? 'fa fa-star' : 'fa fa-star-o';
    },
    onSelect (rating) {
      this.sheetVisible = false;
      this.submit(rating);
    },
    submit (rating) {
      if (this.value === rating) return;
      this.$store.dispatch('learningObject/setRatings', {
        LearningObjectId: this.learningObject.id,
        Rating: rating
      });
    }
  }
};
</script>

<style scoped>
.lesson-rating {
  display: contents;
}

.rating-love i {
    margin-right: 4px;
    font-size: 20px;
}
</style>
